export default function handleTrackingScript(trackingUrl) {
  let isTrackingAllowed = false

  const addTrackingScript = () => {
    const scriptTag = document.createElement('script')
    scriptTag.setAttribute('type', 'text/javascript')
    scriptTag.setAttribute('data-consent-type', 'tracking')
    scriptTag.setAttribute('src', trackingUrl)
    document.head.appendChild(scriptTag)
  }

  document.addEventListener('onCookieSettingsInitialized', function () {
    isTrackingAllowed = window.CookieSettingsManager.getStatusForCategory('tracking')

    if (isTrackingAllowed) {
      addTrackingScript()
    }
  })

  document.addEventListener('onCookieSettingsChanged', function () {
    const oldStatus = isTrackingAllowed
    isTrackingAllowed = window.CookieSettingsManager.getStatusForCategory('tracking')

    if (oldStatus === true && isTrackingAllowed === false) {
      window.location.reload()
    }

    if (oldStatus === false && isTrackingAllowed === true) {
      addTrackingScript()
    }
  })
}
